import { useIntl } from "react-intl";
import { SelectContainer } from "../AnalyticsTable/styles";
import { Select } from "./styles";

const { Option } = Select;

export default function SelectFilter({
  value,
  setValue,
  label,
  options,
  handleReset,
  disabled = false,
  fit = false,
  allowAll = true,
}) {
  const intl = useIntl();

  const handleChange = (value) => {
    if (handleReset) {
      handleReset();
    }
    setValue(value ?? "");
  };

  const labelIntl = intl.formatMessage({
    id: label,
  });
  const noOptions = intl.formatMessage({
    id: "noOptions",
  });

  return (
    <SelectContainer fit={fit}>
      <span>{labelIntl}:</span>

      <Select
        showSearch
        value={!allowAll && value === "" ? undefined : value}
        onChange={handleChange}
        disabled={disabled}
        allowClear={!allowAll}
        placeholder={intl.formatMessage({ id: "select" })}
        optionFilterProp="children"
        notFoundContent={<div>{noOptions}</div>}
      >
        {allowAll && (
          <Option value="">
            {intl.formatMessage({
              id: "all",
            })}
          </Option>
        )}
        {options.map((opt, i) => (
          <Option value={opt.value} key={i}>
            {opt.label}
          </Option>
        ))}
      </Select>
    </SelectContainer>
  );
}
